import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import PercentIcon from '@mui/icons-material/Percent';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from "axios"
import { AXIOS_API_INSTANCE } from "../../Constants"
import { send_authorized_request } from "../../Constants/cognito"
import {
    InputAdornment,
    Checkbox,
    FormControlLabel,
    Tooltip,
    InputLabel,
    FormControl,
    MenuItem,
    Select,
    Grid,
    IconButton,
    Box,
} from "@mui/material"
import { useSnackbar } from 'notistack';

const options = [
    { name: "Percentage", value: "PERCENTAGE" },
    { name: "Flat Rate", value: "FLAT_RATE" },
    { name: "Flat Rate Per Bulk Item", value: "FLAT_RATE_PER_ITEM" },
]

export default function FeeModal({
    fee,
    open,
    closeModal,
    creatingNewFee,
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [my_fee, setFee] = React.useState(fee || {})
    React.useEffect(() => {
        setFee(fee)
    }, [fee])

    const handleChange = (prop) => (event, sometimes_new_value) => {
        console.log(my_fee)
        if (["refundable"].includes(prop)) {
            setFee({ ...my_fee, [prop]: event.target.checked })
        } else if (["optional"].includes(prop)) {
            setFee({ ...my_fee, [prop]: !event.target.checked })
        } else if (["fee_type"].includes(prop)) {
            setFee({ ...my_fee, [prop]: event.target.value })
        } else if (["calculation"].includes(prop)) {
            setFee({ ...my_fee, [prop]: parseFloat(event.target.value) })
        } else {
            setFee({ ...my_fee, [prop]: event.target.value })
        }
    }

    const save = () => {
        console.log(my_fee)
        console.log("new fee " + creatingNewFee)
        delete my_fee.date_created
        delete my_fee.date_updated
        if (creatingNewFee) {
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.put(`fees`, my_fee).then(
                    axios.spread(() => {
                        enqueueSnackbar('Successfully created fee', { variant: 'success' })
                        closeModal(true)
                    })
                )
            )
        } else {
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.post(`fees/${my_fee.id}`, my_fee).then(
                    axios.spread(() => {
                        enqueueSnackbar('Successfully updated fee', { variant: 'success' })
                        closeModal(true)
                    })
                )
            )
        }
    }
    const delete_fee = () => {
        console.log('delete fee')
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.delete(`fees/${my_fee.id}`).then(
                axios.spread(() => {
                    enqueueSnackbar('Successfully deleted fee', { variant: 'success' })
                    closeModal(true)
                })
            )
        )
    }

    if (my_fee === null || my_fee === undefined) {
        return <div></div>
    }

    return (
        (<div>
            <Dialog
                open={open}
                onClose={closeModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <DialogTitle>
                    {creatingNewFee ? "Creating Fee" : "Modifying Fee"}
                    <IconButton
                        aria-label="close"
                        onClick={closeModal}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container direction="column" spacing={1}>
                        <Grid xs>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="name"
                                label="name"
                                type="text"
                                fullWidth
                                variant="filled"
                                value={my_fee.name || ""}
                                onChange={handleChange("name")}
                            />
                        </Grid>
                        <Grid xs>
                            <Grid container spacing={3} alignItems={"center"} justifyContent={"space-between"} >
                                <Grid xs>
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="calculation"
                                        label="Calculation"
                                        type="number"
                                        fullWidth
                                        variant="filled"
                                        value={my_fee.calculation || 0}
                                        onChange={handleChange("calculation")}
                                        slotProps={{
                                            input: {
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        {my_fee.fee_type === 'PERCENTAGE' ? <PercentIcon /> : <AttachMoneyIcon />}
                                                    </InputAdornment>
                                                ),
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid xs>
                                    <FormControl>
                                        <InputLabel id="demo-simple-select-label">Type</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={my_fee.fee_type}
                                            label="Type"
                                            onChange={handleChange("fee_type")}
                                            sx={{ width: "220px" }}
                                        >
                                            {options.map((option) =>
                                                < MenuItem value={option.value}>{option.name}</MenuItem>
                                            )
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid xs>

                            <Grid container direction="column" spacing={0}>
                                <Grid xs>
                                    <Tooltip
                                        title="Is the fee optional as part of a typical transaction, such as a delivery fee?"
                                        arrow
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    sx={{ paddingTop: "4px", paddingBottom: "4px" }}
                                                    checked={!my_fee.optional ?? true}
                                                    onChange={handleChange("optional")}
                                                />
                                            }
                                            label="Required"
                                        />
                                    </Tooltip>
                                </Grid>
                                <Grid xs>
                                    <Tooltip
                                        title="Is the fee refundable as part of a typical transaction?"
                                        arrow
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    sx={{ paddingTop: "4px", paddingBottom: "4px" }}
                                                    checked={my_fee.refundable || false}
                                                    onChange={handleChange("refundable")}
                                                />
                                            }
                                            label="Refundable"
                                        />
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                        <Grid xs="auto">
                            {!creatingNewFee &&
                                <Tooltip title={my_fee.deletable_reason}>
                                    <span> {/* span required for tooltip events */}
                                        <Button disabled={!my_fee.deletable} variant='outlined' color='error' onClick={delete_fee} sx={{ mr: 1 }}>
                                            <DeleteIcon /> <Box sx={{ pl: 1 }}><span>Delete</span></Box>
                                        </Button>
                                    </span>
                                </Tooltip>
                            }
                        </Grid>
                        <Grid xs="auto">
                            <Button variant="contained" autoFocus onClick={save}>
                                {creatingNewFee ? "Create" : "Save"}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div >)
    );
}
